import {DateRange} from 'rsuite/DateRangePicker';
import {t} from '@lingui/core/macro';

const pad = (value: number) => value.toString().padStart(2, '0');

const toTime = (date: Date) => `${pad(date.getHours())}:${pad(date.getMinutes())}`;

export function getLogTimeFromParams(searchParams: URLSearchParams): {startTime: string, endTime: string} {
    const after = searchParams.get('checkedAt[after]');
    const before = searchParams.get('checkedAt[before]');

    if (after && before) {
        return {startTime: toTime(new Date(after)), endTime: toTime(new Date(before))};
    }

    return {startTime: '00:00', endTime: '23:59'};
}

export function getLogMinDate(now = new Date()): Date {
    const date = new Date(now);
    date.setDate(date.getDate() - 30);
    date.setHours(0, 0, 0, 0);
    return date;
}

export function validateLogDateRange(value: DateRange | null | undefined, minDate: Date): string | undefined {
    if (!value || !value[0] || !value[1]) {
        return t`Обязательно укажите диапазон дат`;
    }

    const [start, end] = value;

    if (start > end) {
        return t`Конечная дата не может быть раньше начальной`;
    }

    if (start < minDate) {
        return t`Дата не может быть раньше чем 30 дней назад`;
    }

    const startDay = new Date(start);
    startDay.setHours(0, 0, 0, 0);

    const endDay = new Date(end);
    endDay.setHours(0, 0, 0, 0);

    if (startDay.getTime() !== endDay.getTime()) {
        return t`Диапазон должен быть в пределах одних суток`;
    }

    return undefined;
}

interface ILogFiltersValues {
    code?: string,
    message?: string,
    checkedAt: DateRange,
}

export function buildLogSearchParams(searchParams: URLSearchParams, data: ILogFiltersValues): URLSearchParams {
    const params = new URLSearchParams(searchParams);

    if (data.code) {
        params.set('code', data.code);
    } else {
        params.delete('code');
    }
    if (data.message) {
        params.set('message', data.message);
    } else {
        params.delete('message');
    }

    const [start, end] = data.checkedAt;
    params.set('checkedAt[after]', start.toISOString());

    const endInclusive = new Date(end);
    endInclusive.setSeconds(59, 999);
    params.set('checkedAt[before]', endInclusive.toISOString());

    params.set('page', '1');

    return params;
}
